// extracted by mini-css-extract-plugin
export default {"AppLink":"AppLink_AppLink__DBDj3","White":"AppLink_White__iO7Zz"};